import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  reindexFile,
  ReindexFileResponse,
} from '@/services/data-sources/reindex-file';

interface ReindexFileVariables {
  collectionId: string;
  filename: string;
}

type Options = Omit<
  UseMutationOptions<ReindexFileResponse, Error, ReindexFileVariables>,
  'mutationFn'
>;

export const useReindexFile = (options?: Options) => {
  return useMutation<ReindexFileResponse, Error, ReindexFileVariables>({
    mutationFn: async (vars) => {
      const response = await reindexFile(vars);
      if (response?.detail) {
        throw new Error(response.detail);
      }
      return response;
    },
    ...options,
  });
};
